<template>
  <v-row class="pa-0" justify="center" align="center">
    <v-col>
      <template v-if="$vuetify.breakpoint.smAndUp && !isOnSide">
        <v-card
          v-for="n in 2"
          :key="'empty_' + n"
          elevation="0"
          class="rounded-lg mb-4 text-start"
          :class="n === 2 ? 'ms-16' : 'me-16'"
        >
          <div class="d-inline-flex">
            <v-skeleton-loader
              v-bind="skeletonOptions"
              :width="imageSize"
              :height="imageSize - 10"
              type="image"
              class="rounded-lg ma-2"
            />

            <div class="ma-2 ms-0 align-self-center">
              <v-skeleton-loader
                v-bind="skeletonOptions"
                :width="textSize"
                height="12"
                type="text"
                class="mb-2"
              />

              <v-skeleton-loader
                v-bind="skeletonOptions"
                :width="textSize"
                height="12"
                type="text"
                class="mb-2"
              />

              <v-skeleton-loader
                v-bind="skeletonOptions"
                :width="textSize - 100"
                height="12"
                type="text"
              />
            </div>
          </div>
        </v-card>
      </template>

      <div v-if="heading" class="textLight--text subtitle-1 mt-4 text-center">
        {{ heading }}
      </div>

      <div
        v-if="body"
        class="textLight--text caption font-weight-regular"
        style="opacity: 0.5"
      >
        {{ body }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
    },
    body: {
      type: String,
    },
    isOnSide: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      skeletonOptions: {
        boilerplate: true,
      },
    };
  },
  computed: {
    imageSize() {
      return this.isOnSide ? 70 : 70;
    },
    textSize() {
      return this.isOnSide ? 180 : 180;
    },
  },
};
</script>
